// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as RadiobuttonCheckedComponent} from './RadiobuttonChecked.svg';

import Icon, { TIconProps } from '../Icon';

export const IconRadiobuttonChecked = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <RadiobuttonCheckedComponent/>
  </Icon>
));
